import { disableMuffle, enableMuffle } from "../sound_api/effects/Muffle";
import { playConnectionEffect } from "../sound_api/utils/AudioManager";
import { AuthData } from "../types/AuthData";
import { CoreData } from "../types/CoreData";
import { coreDataStore } from "./CoreDataStorage";
import { getConnectionPacket, getDisconnectPacket } from "./Packets";
import { PacketType } from "./PacketType";
import { Howl, Howler } from "howler";

export function buildWebSocketClient(
  url: string,
  port: number,
  token: string,
  setLoggedOut: () => void,
  setAuthData: (data: AuthData) => void,
): WebSocket {
  const socket = new WebSocket(url);
  handleError(socket);
  handleClose(socket, token, setLoggedOut);
  implementPacketListener(socket, token, setLoggedOut, setAuthData);
  socket.addEventListener("open", (event: Event) => {
    console.log(`Websocket-Connection established for port: => ${port}!`);
    sendConnectionEvent(socket, token);
    keepAlive(socket);
  });
  window.addEventListener("beforeunload", (event) => {
    sendDisconnectEvent(socket, token);
  });

  return socket;
}

export function closeWebsocket(ws: WebSocket): void {
  ws.close();
}

export function implementPacketListener(
  ws: WebSocket,
  token: string,
  setLoggedOut: () => void,
  setAuthData: (data: AuthData) => void,
): void {
  ws.onmessage = (event: MessageEvent) => {
    const data = JSON.parse(event.data);

    if (!("type" in data)) return;

    const isCoreData = data.type === PacketType.CORE_DATA;
    const isValidToken = isCoreData || data.token === token;

    if (!isValidToken) return;

    console.log(data);

    switch (data.type) {
      case PacketType.AUTH:
        setAuthData({
          name: data.name,
          rank: data.rank,
          server: data.server,
          uuid: data.uuid,
        });
        playConnectionEffect();
        break;

      case PacketType.FAILED_AUTH:
        setLoggedOut();
        closeWebsocket(ws);
        break;

      case PacketType.CORE_DATA:
        coreDataStore.core_data = data as CoreData;
        break;

      case PacketType.AUDIO_MUFFLE_MANIPULATION:
        if (data.muffle == true) {
          enableMuffle();
        } else {
          disableMuffle();
        }
        break;
    }
  };
}

const keepAlive = (ws: WebSocket): void => {
  setInterval(() => {
    if (ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify({ type: PacketType.PING.toString() }));
    }
  }, 30000);
};

const handleError = (ws: WebSocket): void => {
  ws.onerror = (event: Event) => {
    console.log("-----Websocket Error-----");
    console.log(event);
  };
};

const handleClose = (
  ws: WebSocket,
  token: string,
  setLoggedOut: () => void,
) => {
  ws.onclose = (event: CloseEvent) => {
    Howler.unload();
    setLoggedOut();
    sendDisconnectEvent(ws, token);
    if (event.wasClean) {
      console.log(
        `Websocket-connection closed cleanly, code=${event.code}, reason=${event.reason}`,
      );
    } else {
      console.log("Websocket-connection died");
    }
  };
};

export const sendDisconnectEvent = (ws: WebSocket, token: string) => {
  ws.send(JSON.stringify(getDisconnectPacket(token)));
};

export const sendConnectionEvent = (ws: WebSocket, token: string) => {
  ws.send(JSON.stringify(getConnectionPacket(token)));
};
